<template>
	<b-modal
		id="discardChangePersonal"
		size="md"
		centered
		hide-footer
		hide-header
		v-model="showModal"
		no-close-on-backdrop
		@hidden="$emit('close-modal')"
	>
		<div class="d-flex">
			<div class="w-100">
				<div
					class="candash-modal-top justify-content-start no-border-bottom p-3 align-items-start"
				>
					<div>
						<img src="@/assets/New Profile/warning-icon-small.svg" alt="" height="55" width="55" />
					</div>
					<div class="w-neg33 pl-3">
						<div class="d-flex align-items-center justify-content-between">
							<div class="candash-modal-head">Discard Changes</div>
							<div
								class="d-flex justify-content-end pointer cross-icon-pos"
								@click="$emit('close-modal')"
							>
								<img
									class="rotate-on-hover"
									src="@/assets/newdesign/dashboard/blueCross.svg"
									alt=""
								/>
							</div>
						</div>
						<div class="candash-modal-label mt-2 pr-3">
							Are you sure you want to discard the data you entered?
						</div>
					</div>
				</div>

				<div
					class="p-3 no-border-top d-flex align-items-center justify-content-end"
				>
					<b-button class="candash-cancelBtn mr-4" @click="$emit('close-modal')"
						>Cancel</b-button
					>
					<b-button class="candash-addBtn" @click="$emit('discard-changes')"
						>Discard</b-button
					>
				</div>
			</div>
		</div>
	</b-modal>
</template>

<script>
export default {
	name: "DiscardModal",
	props: {
		showModal: Boolean,
	},
};
</script>

<style>
.w-neg33 {
	width: calc(100% - 33px);
}
</style>
